import skillsData from '../data/skills.json';
import technologiesData from '../data/technologies.json';
import skillTechnologies from '../data/skill_technologies.json';

import { Skill } from '../models/skill.interface';
import { Technology } from '../models/technology.interface';

export class SkillsService {
    private skills: Skill[] = [];
    private technologies: Technology[] = [];

    constructor() {
        this.technologies = technologiesData.technologies as Technology[];
        this.skills = skillsData.skills.map((skill: any) => {
            const techLinks = skillTechnologies.skill_technologies.filter(st => st.skill_id === skill.id);
            const technologies: Technology[] = [];
            techLinks.forEach(link => {
                const found = this.technologies.find(t => t.id === link.technology_id);
                if (found) technologies.push(found);
            });
            return { id: skill.id, name: skill.name, technologies } as Skill;
        });
    }

    fetchSkills(): Skill[] {
        return this.skills;
    }

    getTechnologies(): Technology[] {
        return this.technologies;
    }
}

export const skillsService = new SkillsService();
